import SupportLinkGenerator from '../Components/Support/SupportLinkGenerator';

function BusinessSupportLinksPage() {
  return <SupportLinkGenerator />;
}

export default BusinessSupportLinksPage;
